import { Mail, MapPin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SEO from '@/components/SEO';

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-cyan-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
      <SEO
        title="Contact Toonah — Get in Touch"
        description="Contact Toonah for support, safety reports, press or partnership enquiries about our anonymous video chat platform."
        path="/contact"
      />
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 glass-card">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <button onClick={() => navigate('/')} className="text-2xl font-black">← Toonah</button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <div className="glass-card p-8 md:p-12 rounded-3xl text-center">
          <h1 className="text-4xl font-black mb-8">Get in Touch</h1>
          <p className="text-lg text-slate-600 dark:text-slate-400 mb-12">
            Have questions or feedback? We'd love to hear from you.
          </p>

          <div className="max-w-md mx-auto space-y-6">
            <div className="glass-card p-6 rounded-2xl" data-testid="contact-email-card">
              <Mail className="w-10 h-10 text-blue-600 mx-auto mb-3" />
              <p className="text-sm font-semibold text-slate-500 mb-1">Email</p>
              <a
                href="mailto:nirmalrajupdates@gmail.com"
                data-testid="contact-email-link"
                className="text-lg font-bold text-blue-600 hover:text-blue-700 transition-colors"
              >
                nirmalrajupdates@gmail.com
              </a>
            </div>

            <div className="glass-card p-6 rounded-2xl" data-testid="contact-location-card">
              <MapPin className="w-10 h-10 text-purple-600 mx-auto mb-3" />
              <p className="text-sm font-semibold text-slate-500 mb-1">Location</p>
              <p className="text-lg font-bold" data-testid="contact-location-text">Hyderabad, India</p>
            </div>
          </div>

          <p
            data-testid="contact-brand-line"
            className="mt-10 text-sm italic text-slate-500 dark:text-slate-400"
          >
            From Hyderabad, India — for conversations everywhere.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
